import { API_CRM_INTERESTS_SYNC_PREFIX, API_CRM_PRODUCTS_SYNC_PREFIX } from '@shared/config/api/api-prefixes';
import { productBaseApi } from '@entities/product/api/base';
import { SyncCRMDataResponse } from '@features/product/crm-sync/api/crm-sync-types';

export const crmSyncApi = productBaseApi.injectEndpoints({
    endpoints: (build) => ({
        syncCRMInterests: build.mutation<SyncCRMDataResponse, void>({
            query: () => {
                return {
                    url: API_CRM_INTERESTS_SYNC_PREFIX,
                    method: 'POST',
                    body: {},
                };
            },
            invalidatesTags: ['ProductsList'],
        }),
        syncCRMProducts: build.mutation<SyncCRMDataResponse, void>({
            query: () => {
                return {
                    url: API_CRM_PRODUCTS_SYNC_PREFIX,
                    method: 'POST',
                    body: {},
                };
            },
            invalidatesTags: ['ProductsList'],
        }),
    }),
});

export const { useSyncCRMInterestsMutation, useSyncCRMProductsMutation } = crmSyncApi;
